<div class="card-header d-flex justify-content-between align-items-center bg-light">
   <span class="medicalTitle">
      {{ title }}
      <span class="required-asterisk">*</span>
   </span>
   <span class="text-muted small">(Max {{ maxSelection }})</span>
</div>

<div class="card-body">
   <div class="row row-cols-2 interestRows">
      <div
         class="col"
         *ngFor="let interest of interests">
         <vc-checkbox
            [inputId]="idPrefix + '-' + interest.id"
            [label]="interest.name"
            [required]="true"
            [disabled]="isDisabled(interest)"
            [ngModel]="isChecked(interest)"
            (ngModelChange)="toggleSelection(interest)"></vc-checkbox>
      </div>
   </div>
</div>
